import { Currency } from '@models';
import { api } from '@services';
import { Convert } from '@utils';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/RATEARCHIVE') => `${reducer}/${actionType}`;

export const getCurrencyList = (type = '') => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const $currencyList = res.info.products.filter((item) => item?.SYMBOL !== 'IRR') || [];

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					selectBox: {
						...getState().page.rateArchive.selectBox,
						$currencyList: Currency.getList($currencyList, 'SYMBOL'),
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					selectBox: {
						...getState().page.rateArchive.selectBox,
						$currencyList: [],
					},
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					selectBox: {
						...getState().page.rateArchive.selectBox,
						_currencyList: status,
					},
				},
			});
		};

		api.$product_fetch_type({ onOK, onFail, onStatus }, { type: type || 'C', isUpdated: true });
	};
};

export const getArchive = () => {
	return async (dispatch, getState) => {
		const { symbol, period, fromDate, toDate } = getState().page.rateArchive.selectBox;

		const sliceDate = (d = fromDate) => {
			let date = Convert.newDateToFaDate(d);

			switch (period.value) {
				case 'M':
					date = date.slice(0, 6);
					break;
				case 'Y':
					date = date.slice(0, 4);
					break;
				default:
					break;
			}

			return date;
		};

		const onOK = async (res) => {
			const $list = res.info || [];

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					$list,
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					$list: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.rateArchive,
					_list: status,
				},
			});
		};

		api.$product_fetch_archive(
			{ onOK, onFail, onStatus },
			{
				symbol: symbol.symbol || symbol.SYMBOL,
				period: period.value,
				fromDate: sliceDate(fromDate),
				// fromDate: Convert.newDateToFaDate(fromDate),
				toDate: sliceDate(toDate),
				// toDate: Convert.newDateToFaDate(toDate),
			},
		);
	};
};
